<template>
  <v-container fluid class="claim-page">
    <!-- Alert -->
    <AAlertBanner :messages="alertError" hide-title />

    <!-- Confirmation Dialog -->
    <v-dialog v-model="emailPaymentAdviceDialog" max-width="460" content-class="claim-confirm-dialog">
      <div class="claim-confirm-card">
        <h3 class="claim-confirm-card__title">{{ this.model.name.singular }}</h3>
        <p class="claim-confirm-card__message">Please confirm that you wish to send Email Payment Advice to Client</p>
        <div class="claim-confirm-card__actions">
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--cancel"
            @click="emailPaymentAdviceDialog = false"
          >
            Cancel
          </button>
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--confirm"
            @click="modalEmailPaymentAdviceSubmit()"
          >
            Submit
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Header -->
    <div class="claim-header">
      <div class="claim-header__top">

        <div v-if="!loadingDialog" class="claim-header__info">
          <h1 class="claim-header__title">
            {{ model.add.name }}
          </h1>
        </div>

        <div class="claim-header__actions">
          <span v-if="isTaxpodAdminRoles && !btnDisabled && !editMode">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--green"
                  :disabled="apiSubmit.isLoading"
                  @click="emailPaymentAdviceDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="18">mdi-check-circle</v-icon>
                </button>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </span>
        </div>
      </div>
    </div>

    <!-- CN Check Status Banner -->
    <div v-if="cnCheckDisplay" class="cn-status-banner" :class="cnCheckResult ? 'cn-status-banner--success' : 'cn-status-banner--error'">
      <div class="cn-status-banner__icon">
        <svg v-if="cnCheckResult" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="20" height="20">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="20" height="20">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
      </div>
      <span class="cn-status-banner__text">{{ cnCheckStatus.cnCheckMsg }}</span>
    </div>

    <!-- Dates Section -->
    <div class="dates-row">
      <div class="date-card">
        <span class="date-card__label">Finance Refund Date</span>
        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <div class="date-card__trigger" v-bind="attrs" v-on="on">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" /></svg>
              <span class="date-card__value">{{ formData.financeRefundToClientDate || 'Select date' }}</span>
            </div>
          </template>
          <v-date-picker v-model="formData.financeRefundToClientDate" no-title scrollable color="var(--app-accent)">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="date-card">
        <span class="date-card__label">Email Payment Advice Date</span>
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <div class="date-card__trigger" v-bind="attrs" v-on="on">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" /></svg>
              <span class="date-card__value">{{ formData.emailPaymentAdviceToClientDate || 'Select date' }}</span>
            </div>
          </template>
          <v-date-picker v-model="formData.emailPaymentAdviceToClientDate" no-title scrollable color="var(--app-accent)">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </div>

    <!-- Email Compose Card -->
    <div class="email-compose">
      <!-- Email toolbar -->
      <div class="email-compose__toolbar">
        <div class="email-compose__toolbar-left">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
          </svg>
          <span class="email-compose__toolbar-title">New Message</span>
        </div>
      </div>

      <!-- Email header fields -->
      <div class="email-compose__fields">
        <!-- Subject -->
        <div class="email-field">
          <span class="email-field__label">Subject</span>
          <div class="email-field__value">
            <v-text-field
              dense
              solo
              flat
              hide-details
              v-model="formData.emailSubject"
              :error-messages="errorField.emailSubject"
              readonly
              class="email-field__input"
            ></v-text-field>
          </div>
        </div>

        <!-- To -->
        <div class="email-field">
          <span class="email-field__label">To</span>
          <div class="email-field__value">
            <v-combobox
              dense
              solo
              flat
              hide-details
              v-model="formData.toEmail"
              :error-messages="errorField.toEmail"
              :hide-selected="true"
              multiple
              small-chips
              :readonly="editMode"
              class="email-field__input"
            >
              <template v-slot:selection="data">
                <v-chip
                  small
                  color="#e0f2fe"
                  text-color="#0369a1"
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                  class="email-chip"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="12" height="12" class="mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>
                  {{ data.item }}
                  <v-icon small @click="data.parent.selectItem(data.item)" class="ml-1">$delete</v-icon>
                </v-chip>
              </template>
              <template v-slot:append>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="var(--app-text-faint)">mdi-information-outline</v-icon>
                  </template>
                  Press <kbd>enter/tab</kbd> to insert multiple email
                </v-tooltip>
              </template>
            </v-combobox>
          </div>
        </div>

        <!-- Cc -->
        <div class="email-field">
          <span class="email-field__label">Cc</span>
          <div class="email-field__value">
            <v-combobox
              dense
              solo
              flat
              hide-details
              v-model="formData.ccEmail"
              :error-messages="errorField.ccEmail"
              :hide-selected="true"
              multiple
              small-chips
              :readonly="editMode"
              class="email-field__input"
            >
              <template v-slot:selection="data">
                <v-chip
                  small
                  color="#f1f5f9"
                  text-color="#475569"
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                  class="email-chip"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="12" height="12" class="mr-1"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>
                  {{ data.item }}
                  <v-icon small @click="data.parent.selectItem(data.item)" class="ml-1">$delete</v-icon>
                </v-chip>
              </template>
              <template v-slot:append>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="var(--app-text-faint)">mdi-information-outline</v-icon>
                  </template>
                  Press <kbd>enter/tab</kbd> to insert multiple email
                </v-tooltip>
              </template>
            </v-combobox>
          </div>
        </div>
      </div>

      <!-- Attachments area (inside email compose) -->
      <div class="email-attachments">
        <div class="email-attachments__header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="15" height="15">
            <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
          </svg>
          <span>Attachments</span>
        </div>

        <!-- Hidden v-file-inputs -->
        <v-file-input
          ref="refundPaymentAdviceInput"
          class="d-none"
          :prepend-icon="null"
          multiple
          accept=".pdf"
          v-model="formData.refundPaymentAdvice"
          :error-messages="errorField.refundPaymentAdvice"
          :truncate-length="1000"
          @change="scanPdf($event)"
        ></v-file-input>
        <v-file-input
          class="d-none"
          :prepend-icon="null"
          dense filled small-chips multiple
          accept=".pdf"
          v-model="formData.creditNote"
          :error-messages="errorField.creditNote"
          :truncate-length="1000"
          disabled
        ></v-file-input>

        <div class="email-attachments__list">
          <!-- Refund Payment Advice -->
          <div
            class="email-atch"
            :class="{ 'email-atch--empty': !formData.refundPaymentAdvice || formData.refundPaymentAdvice.length === 0 }"
            v-cloak
            @drop.prevent="addDropFile($event, 'refundPaymentAdvice')"
            @dragover.prevent
          >
            <div class="email-atch__icon email-atch__icon--pdf">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
              </svg>
            </div>
            <div class="email-atch__info">
              <span class="email-atch__name">
                {{ formData.refundPaymentAdvice && formData.refundPaymentAdvice.length > 0
                  ? formData.refundPaymentAdvice.map(function(f) { return f.name }).join(', ')
                  : 'Refund Payment Advice' }}
              </span>
              <span class="email-atch__meta">
                {{ formData.refundPaymentAdvice && formData.refundPaymentAdvice.length > 0
                  ? formData.refundPaymentAdvice.length + ' file(s)'
                  : 'No file — click to upload' }}
              </span>
            </div>
            <div class="email-atch__actions">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <button class="email-atch__btn" v-on="on" @click.stop="$refs.refundPaymentAdviceInput.$refs.input.click()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                    </svg>
                  </button>
                </template>
                <span>Upload</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <button class="email-atch__btn" @click.stop="previewAutoEmbedPdf('refundPaymentAdvice')" v-on="on">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  </button>
                </template>
                <span>Preview</span>
              </v-tooltip>
            </div>
          </div>

          <!-- Credit Note -->
          <div class="email-atch email-atch--locked">
            <div class="email-atch__icon email-atch__icon--cn">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25Z" />
              </svg>
            </div>
            <div class="email-atch__info">
              <span class="email-atch__name">
                {{ formData.creditNote && formData.creditNote.length > 0
                  ? formData.creditNote.map(function(f) { return f.name }).join(', ')
                  : 'Credit Note' }}
              </span>
              <span class="email-atch__meta">
                {{ formData.creditNoteNo ? 'CN: ' + formData.creditNoteNo : 'Auto-attached from system' }}
              </span>
            </div>
            <div class="email-atch__lock-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="12" height="12">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
              Auto
            </div>
          </div>
        </div>

        <div v-if="errorField.refundPaymentAdvice" class="field-error" style="padding: 0 20px 8px;">
          {{ Array.isArray(errorField.refundPaymentAdvice) ? errorField.refundPaymentAdvice.join(', ') : errorField.refundPaymentAdvice }}
        </div>
        <div v-if="errorField.creditNote" class="field-error" style="padding: 0 20px 8px;">
          {{ Array.isArray(errorField.creditNote) ? errorField.creditNote.join(', ') : errorField.creditNote }}
        </div>
      </div>

      <!-- Email body -->
      <div class="email-compose__body">
        <tiptap-vuetify
          v-model="formData.emailContent"
          :extensions="extensions"
        />
        <div v-if="errorField.emailContent" class="field-error" style="padding: 0 20px 12px;">
          {{ errorField.emailContent ? errorField.emailContent[0] : null }}
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  mixins: [hrdcFunction],
  components: {
    TiptapVuetify,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    cnCheckStatus() {
      let color = "red lighten-2";
      let cnCheckMsg =
        "CN No. is not same as system CN No, kindly double check before proceed";
      let cnAlertType = "error";

      if (this.cnCheckResult) {
        color = "green lighten-2";
        cnCheckMsg = "Payment Advice CN No. checked pass";
        cnAlertType = "success";
      }

      return {
        color,
        cnCheckMsg,
        cnAlertType,
      };
    },
  },
  props: ["params"],
  data: () => ({
    apiGetApplicationSingleDetail: new Api(),
    apiScanPdfText: new Api(),
    apiSubmit: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu2: false,
    formData: {
      applicationNo: null,
      emailPaymentAdviceToClientDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      refundPaymentAdvice: [],
      creditNote: [],
      toEmail: [],
      ccEmail: [],
      toEmailUuid: [],
      ccEmailUuid: [],
      emailSubject: null,
      emailContent: `Hi,<br><br>Good day to you, enclosed herewith the Credit Note and Refund Payment Advice for your records.`,
      creditNoteNo: null,
      financeRefundToClientDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
    },
    errorField: {
      applicationNo: null,
      refundPaymentAdvice: null,
      creditNote: null,
      emailContent: null,
      toEmail: null,
      ccEmail: null,
      emailSubject: null,
      emailPaymentAdviceToClientDate: null,
      creditNoteNo: null,
      financeRefundToClientDate: null,
    },
    loadingDialog: false,
    emailPaymentAdviceDialog: false,
    editMode: false,
    btnDisabled: false,
    cnCheckResult: false,
    cnCheckDisplay: false,
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
  }),
  async created() {
    this.showLoadingDialog();
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/email_payment_advice/create-email-payment-advice`,
        method: "post",
      },
      apiGetApplicationSingleDetail: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-single-application`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
      apiScanPdfText: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/email_payment_advice/scan-pdf`,
        method: "post",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.stages = await this.hrdcData.allStages;
    const currentStageId =
      this.hrdcData.stageIndex[this.$store.state.hrdc.data.stageId];
    this.rolesAssignation(this.auth.roles);
    if (!this.isTaxpodAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.checkFormAlreadyFilledGte(
      currentStageId,
      this.hrdcData.stageSlug.emailPaymentAdviceToClient
    );

    this.checkFormNotYetFilledLesser(
      currentStageId,
      this.hrdcData.stageSlug.apSubmitRefundToCimb
    );

    if (this.editMode) {
      this.apiGetApplicationSingleDetail.fetch();
      this.apiGetApplicationSingleDetail.setCallbackCompleted((response) => {
        try {
          const { status, data } = response;
          if (status) {
            const emailPaymentAdviceStageId =
              this.hrdcData.stagePriority.emailPaymentAdviceToClient;
            const financeRefundToClientStageId =
              this.hrdcData.stagePriority.financeRefundToClient;

            // Email Payment Advice to Client date.
            this.formData.emailPaymentAdviceToClientDate = moment(
              data.ApplicationLog.find(
                (obj) => obj.stageId == emailPaymentAdviceStageId
              ).startDate
            ).format("YYYY-MM-DD");

            // Finance Refund to Client date.
            this.formData.financeRefundToClientDate = moment(
              data.ApplicationLog.find(
                (obj) => obj.stageId == financeRefundToClientStageId
              ).startDate
            ).format("YYYY-MM-DD");

            this.formData.creditNoteNo = data.creditNoteNo;
          }

          this.hideLoadingDialog();
        } catch (err) {
          console.log(err);
        }
      });
    } else {
      this.apiGetApplicationSingleDetail.setCallbackCompleted((response) => {
        try {
          const { status, data } = response;
          if (status) {
            this.formData.emailSubject = `Credit Note and Refund Payment Advice For YYC taxPOD - ${data.oriCompanyName.toUpperCase()}`;

            // Get recipient email to (company client email).
            const companyPicEmail = data.CompanyPicDetail.map(
              (item) => item.picEmail
            );

            this.formData.toEmail = companyPicEmail;
            this.formData.ccEmail.push(data.referByEmail);
            this.formData.creditNoteNo = data.creditNoteNo;

            // Get multiple CN object.
            const creditNoteObj = data.ApplicationAttachment.filter(
              (item) =>
                item.stageId == this.hrdcData.stagePriority.creditNoteGenerated
            );

            // Assign attachment.
            for (const item of creditNoteObj) {
              // Create a Blob object from the data
              const blob = new Blob([new Uint8Array(item.dataArray)]);

              // Create the File object
              const file = new File([blob], item.fileName, {
                type: "application/pdf",
              });

              switch (item.type) {
                case "creditNote":
                  this.formData.creditNote.push(file);
                  break;
              }
            }
          }
        } catch (err) {
          console.log(err);
        }

        this.hideLoadingDialog();
      });
      this.apiGetApplicationSingleDetail.fetch();
    }
  },
  methods: {
    clearErrorMsg(field = null) {
      if (!field) {
        for (let error in this.errorField) {
          this.errorField[error] = null;
        }
      } else {
        this.errorField[field] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    modalEmailPaymentAdviceSubmit() {
      this.emailPaymentAdviceDialog = !this.emailPaymentAdviceDialog;
      this.submit();
    },
    addDropFile(e, key) {
      let file = e.dataTransfer.files;

      for (const fileItem of file) {
        if (!fileItem.type.match("pdf.*")) {
          this.errorField.refundPaymentAdvice = "Please select pdf file format";
          return;
        }

        this.formData.refundPaymentAdvice.push(fileItem);
      }

      if (e) {
        this.clearErrorMsg(key);
      }
    },
    previewAutoEmbedPdf(fileType) {
      if (this.formData[fileType].length == 0) {
        this.$store.dispatch("showMessage", {
          message: "No Preview Available",
          messageType: "info",
        });
        return;
      }

      for (let i = 0; i < this.formData.refundPaymentAdvice.length; i++) {
        let url = URL.createObjectURL(this.formData[fileType][i]);
        window.open(url, "_blank");
      }
    },
    scanPdf($event) {
      if ($event.length > 0) {
        this.showLoadingDialog();
        const fd = new FormData();
        fd.append("refundPaymentAdvice", this.formData.refundPaymentAdvice[0]); // Only function when payment advice got 1, else need to manual check for extra Payment Advice.

        this.apiScanPdfText.setParams(fd);
        this.apiScanPdfText.setCallbackCompleted((response) => {
          try {
            if (response.status) {
              const cnNo = response.data;
              this.cnCheckDisplay = true;
              if (cnNo !== this.formData.creditNoteNo) {
                this.cnCheckResult = false;
              }

              if (cnNo == this.formData.creditNoteNo) {
                this.cnCheckResult = true;
              }
            } else {
              this.$store.dispatch("showMessage", {
                message: "Please upload valid Payment Advice",
                messageType: "error",
                timeout: 2000,
              });
            }
            this.hideLoadingDialog();
          } catch (err) {
            console.log(err);
          }
        });
        this.apiScanPdfText.fetch();
      } else {
        this.cnCheckDisplay = false;
      }
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    async submit() {
      this.showLoadingDialog();
      // Generate Form Data to handle multipart/form-data
      const fd = new FormData();
      fd.append("applicationUuid", this.$route.query._ausk);
      fd.append("toEmail", this.formData.toEmail);
      fd.append("ccEmail", this.formData.ccEmail);
      fd.append("emailSubject", this.formData.emailSubject);
      fd.append(
        "emailPaymentAdviceToClientDate",
        this.formData.emailPaymentAdviceToClientDate
      );
      fd.append("referById", this.auth.uuid);
      fd.append("editMode", this.editMode);
      fd.append("emailContent", this.formData.emailContent);
      fd.append(
        "financeRefundToClientDate",
        this.formData.financeRefundToClientDate
      );

      // Loop multiple files upload.
      for (let i = 0; i < this.formData.refundPaymentAdvice.length; i++) {
        fd.append("refundPaymentAdvice", this.formData.refundPaymentAdvice[i]);
      }

      if (this.formData.refundPaymentAdvice) {
        for (let i = 0; i < this.formData.refundPaymentAdvice.length; i++) {
          fd.append(
            "refundPaymentAdviceFileName",
            this.formData.refundPaymentAdvice[i].name
          );
        }
      }

      this.apiSubmit.setParams(fd);
      this.apiSubmit.setCallbackError(() => {
        this.hideLoadingDialog();
        this.$store.dispatch("showMessage", {
          message: "Something went wrong. Please try again later.",
          messageType: "error",
          timeout: 2000,
        });
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          this.hideLoadingDialog();
          if (!response.status) {
            this.showErrorMessage(response);
            if (response.message) {
              this.$store.dispatch("showMessage", {
                message: response.message,
                messageType: "error",
                timeout: 2000,
              });
            }
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$router.push({
              name: "HrdcApplication",
              query: {
                viewId: this.$store.state.hrdc.data.viewId,
              },
            });
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .cn-status-banner--success {
  background: var(--app-success-bg);
}

.dark-mode .cn-status-banner--error {
  background: var(--app-danger-bg);
}

.dark-mode .claim-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-success-bg);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-success-bg);
}

.dark-mode .date-card {
  background: var(--app-form-tile);
}

.dark-mode .date-card__label {
  color: var(--app-text-muted);
}

.dark-mode .date-card__trigger {
  border: 1.5px solid var(--app-field-border);
  background: var(--app-field);
  color: var(--app-text-faint);
}

.dark-mode .date-card__trigger:hover {
  border-color: var(--app-field-border-hover);
  background: var(--app-field-hover);
}

.dark-mode .date-card__value {
  color: var(--app-text);
}

.dark-mode .email-compose {
  background: var(--app-form-tile);
}

.dark-mode .email-compose__fields {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .email-field {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .email-field__label {
  color: var(--app-text-faint);
}

.dark-mode .email-compose__body {
  border-top: 1px solid var(--app-border);
}

.dark-mode .email-attachments {
  border-top: 1px solid var(--app-border);
  background: var(--app-surface);
}

.dark-mode .email-attachments__header {
  color: var(--app-text-faint);
}

.dark-mode .email-atch {
  background: var(--app-form-tile);
  border: 1.5px solid var(--app-border);
}

.dark-mode .email-atch:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .email-atch__icon--pdf {
  background: var(--app-danger-bg);
}

.dark-mode .email-atch__icon--cn {
  background: var(--app-accent-soft);
}

.dark-mode .email-atch__name {
  color: var(--app-text);
}

.dark-mode .email-atch__meta {
  color: var(--app-text-faint);
}

.dark-mode .email-atch__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .email-atch__btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .email-atch__lock-badge {
  background: var(--app-form-tile);
  color: var(--app-text-faint);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .rv-datepicker__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .file-card {
  background: var(--app-form-tile);
}

.dark-mode .file-card--empty {
  border-color: var(--app-border-strong);
}

.dark-mode .file-card--has-file {
  background: var(--app-success-bg);
}

.dark-mode .file-card--disabled {
  border-color: var(--app-border);
  background: var(--app-form-tile);
}

.dark-mode .file-card__icon {
  background: var(--app-form-tile);
}

.dark-mode .file-card--has-file .file-card__icon {
  background: var(--app-success-bg);
}

.dark-mode .file-card--disabled .file-card__icon {
  background: var(--app-form-tile);
}

.dark-mode .file-card__svg {
  color: var(--app-text-muted);
}

.dark-mode .file-card--disabled .file-card__svg {
  color: var(--app-text-faint);
}

.dark-mode .file-card__badge {
  border: 2px solid var(--app-card);
}

.dark-mode .file-card__name {
  color: var(--app-text);
}

.dark-mode .file-card--empty .file-card__name {
  color: var(--app-text-faint);
}

.dark-mode .file-card--disabled .file-card__name {
  color: var(--app-text-faint);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  border: 1px solid var(--app-border);
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .file-card__cn-no {
  background: var(--app-surface);
  border: 1px dashed var(--app-border);
}

.dark-mode .file-card__cn-label {
  color: var(--app-text-faint);
}

.dark-mode .file-card__cn-value {
  color: var(--app-text);
}

.dark-mode .tiptap-container {
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot,
.dark-mode .form-field >>> .v-input--is-readonly .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection,
.dark-mode .form-field >>> .v-input--is-readonly input {
  color: var(--app-text-muted) !important;
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-chip {
  background: var(--app-accent-soft) !important;
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.claim-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  zoom: 1.1;
}

/* ============================================
   CN CHECK STATUS BANNER
   ============================================ */
.cn-status-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.5;
}

.cn-status-banner--success {
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  color: #065f46;
}

.cn-status-banner--success .cn-status-banner__icon {
  color: #10b981;
}

.cn-status-banner--error {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.cn-status-banner--error .cn-status-banner__icon {
  color: #ef4444;
}

.cn-status-banner__icon {
  flex-shrink: 0;
}

.cn-status-banner__text {
  flex: 1;
}

/* ============================================
   HEADER
   ============================================ */
.claim-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.claim-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px 16px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.claim-header__info {
  flex: 1;
  min-width: 0;
}

.claim-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.claim-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;
}

/* ============================================
   HERO ACTION BUTTONS
   ============================================ */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.hero-action-btn--green {
  background: #ecfdf5;
  color: #10b981;
}

.hero-action-btn--green:hover {
  background: #d1fae5;
  color: #059669;
}

/* ============================================
   DATE CARDS (top row)
   ============================================ */
.dates-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}

.date-card {
  background: #fff;
  border: 1px solid #e4e8ec;
  border-radius: 14px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-card__label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.date-card__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #94a3b8;
}

.date-card__trigger:hover {
  border-color: #94a3b8;
  background: #fff;
}

.date-card__value {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e293b;
  font-family: 'Lato', sans-serif;
}

/* ============================================
   EMAIL COMPOSE CARD
   ============================================ */
.email-compose {
  background: #fff;
  border: 1px solid #e4e8ec;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 20px;
}

.email-compose__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e293b, #334155);
  color: #fff;
}

.email-compose__toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.email-compose__toolbar-title {
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.email-compose__fields {
  border-bottom: 1px solid #f1f5f9;
}

.email-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
  min-height: 44px;
}

.email-field:last-child {
  border-bottom: none;
}

.email-field__label {
  flex: 0 0 60px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #94a3b8;
  padding: 10px 0 10px 20px;
}

.email-field__value {
  flex: 1;
  min-width: 0;
  padding: 0 12px;
}

.email-compose__body {
  border-top: 1px solid #e2e8f0;
}

/* ============================================
   EMAIL ATTACHMENTS (inside compose card)
   ============================================ */
.email-attachments {
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.email-attachments__header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  border-bottom: 1px solid #edf2f7;
}

.email-attachments__list {
  display: flex;
  gap: 12px;
  padding: 14px 20px;
  flex-wrap: wrap;
}

.email-atch {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  min-width: 240px;
  flex: 1;
  max-width: 380px;
  transition: all 0.15s ease;
  cursor: default;
}

.email-atch:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.email-atch--empty {
  border-style: dashed;
  background: #fafbfc;
}

.email-atch--locked {
  opacity: 0.75;
}

.email-atch__icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.email-atch__icon--pdf {
  background: #fef2f2;
  color: #ef4444;
}

.email-atch__icon--cn {
  background: #f0f9ff;
  color: #0ea5e9;
}

.email-atch__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.email-atch__name {
  font-size: 0.78rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.email-atch__meta {
  font-size: 0.68rem;
  color: #94a3b8;
  font-weight: 500;
}

.email-atch__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.email-atch__btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.email-atch__btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.email-atch__lock-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #94a3b8;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header--teal {
  background: linear-gradient(135deg, #0d9488, #2dd4bf);
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-body {
  padding: 22px;
  background: #fff;
}

/* ============================================
   FORM ROWS & FIELDS
   ============================================ */
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.form-row--top {
  align-items: flex-start;
}

.form-label {
  flex: 0 0 180px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 10px;
}

.form-field {
  flex: 1;
  min-width: 0;
}

/* ============================================
   DATEPICKER TRIGGER
   ============================================ */
.rv-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
}

.rv-datepicker__trigger:hover {
  border-color: #94a3b8;
}

.rv-datepicker__icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
}

.rv-datepicker__text {
  color: #1e293b;
  font-weight: 600;
}

.rv-datepicker__placeholder {
  color: #94a3b8;
}

/* ============================================
   FILE CARD PATTERN
   ============================================ */
.file-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1.5px solid #e4e8ec;
  background: #fff;
  transition: all 0.2s ease;
}

.file-card--empty {
  border-style: dashed;
  border-color: #d1d5db;
  background: #fafbfc;
}

.file-card--has-file {
  border-color: #6ee7b7;
  background: #f0fdf4;
}

.file-card--disabled {
  border-style: dashed;
  border-color: #e2e8f0;
  background: #f1f5f9;
  cursor: not-allowed;
}

.file-card__icon-wrap {
  position: relative;
  flex-shrink: 0;
}

.file-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card--has-file .file-card__icon {
  background: #dcfce7;
}

.file-card--disabled .file-card__icon {
  background: #e2e8f0;
}

.file-card__svg {
  width: 20px;
  height: 20px;
  color: #64748b;
}

.file-card--has-file .file-card__svg {
  color: #16a34a;
}

.file-card--disabled .file-card__svg {
  color: #94a3b8;
}

.file-card__badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}

.file-card__badge--success {
  background: #10b981;
  color: #fff;
}

.file-card__info {
  flex: 1;
  min-width: 0;
}

.file-card__name {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-card--empty .file-card__name {
  color: #94a3b8;
}

.file-card--disabled .file-card__name {
  color: #94a3b8;
}

.file-card__hint {
  display: block;
  font-size: 0.72rem;
  color: #94a3b8;
  margin-top: 2px;
}

.file-card__actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.file-card__btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.file-card__btn:hover {
  background: #f0f9ff;
  border-color: #0ea5e9;
  color: #0ea5e9;
}

.file-card__btn-icon {
  width: 16px;
  height: 16px;
}

.file-card__cn-no {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #e2e8f0;
}

.file-card__cn-label {
  font-size: 0.65rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.file-card__cn-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: #334155;
  margin-top: 2px;
}

/* ============================================
   TIPTAP CONTAINER
   ============================================ */
.tiptap-container {
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.15s ease;
}

.tiptap-container:focus-within {
  border-color: #56bde8;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12);
}

/* ============================================
   FIELD ERROR
   ============================================ */
.field-error {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
  margin-top: 4px;
  padding-left: 2px;
}

/* ============================================
   VUETIFY INPUT OVERRIDES
   ============================================ */
.form-field >>> .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.form-field >>> .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px !important;
  min-height: 0 !important;
}

.form-field >>> .v-messages {
  min-height: 0 !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.form-field >>> .v-input--is-focused .v-input__slot {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12) !important;
}

.form-field >>> .v-input__slot::before,
.form-field >>> .v-input__slot::after {
  display: none !important;
}

/* Editable fields */
.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #d1d5db !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: #94a3b8 !important;
}

/* Disabled / Readonly fields */
.form-field >>> .v-input--is-disabled .v-input__slot,
.form-field >>> .v-input--is-readonly .v-input__slot {
  background: #f1f5f9 !important;
  border: 1px dashed #e2e8f0 !important;
}

.form-field >>> .v-input--is-disabled input,
.form-field >>> .v-input--is-disabled textarea,
.form-field >>> .v-input--is-disabled .v-select__selection,
.form-field >>> .v-input--is-readonly input {
  color: #64748b !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot::before {
  border: none !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot::after {
  border: none !important;
}

.form-field >>> .v-label {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
}

.form-field >>> .v-text-field input,
.form-field >>> .v-select__selection,
.form-field >>> .v-text-field textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

/* Chip overrides for combobox */
.form-field >>> .v-chip {
  background: #eff6ff !important;
  color: #1e40af !important;
  border: 1px solid #bfdbfe !important;
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
}

.form-field >>> .v-chip .v-icon {
  color: #60a5fa !important;
  font-size: 14px !important;
}

.form-field >>> .v-chip .v-icon:hover {
  color: #ef4444 !important;
}

/* Error state */
.form-field >>> .v-input--has-state .v-input__slot {
  border-color: #f87171 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: #ef4444 !important;
}

.form-field >>> .v-messages__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
}

/* ============================================
   CONFIRM DIALOG
   ============================================ */
.claim-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.claim-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
}

.claim-confirm-card__message {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 24px;
  line-height: 1.5;
}

.claim-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.claim-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.claim-confirm-card__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.claim-confirm-card__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.claim-confirm-card__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.claim-confirm-card__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-btn {
  opacity: 1 !important;
}

.v-messages__message {
  color: #ef4444;
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media (max-width: 599px) {
  .claim-page {
    padding: 12px 8px !important;
    zoom: 1;
    overflow-x: hidden;
  }

  .dates-row {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 14px;
  }

  .email-field__label {
    flex: 0 0 36px;
    font-size: 0.72rem;
    padding-left: 14px;
  }

  .email-field__value {
    padding: 0 8px;
  }

  .email-compose__toolbar {
    padding: 12px 14px;
  }

  .email-compose__toolbar-title {
    font-size: 0.82rem;
  }

  .email-attachments__list {
    flex-direction: column;
    gap: 8px;
    padding: 10px 14px;
  }

  .email-atch {
    max-width: 100%;
    min-width: 0;
  }

  .claim-header {
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .claim-header__top {
    flex-wrap: wrap;
    padding: 16px 16px 12px;
  }

  .back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .claim-header__title {
    font-size: 1.05rem;
    white-space: normal;
  }

  .claim-header__actions {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
  }

  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  .section-card {
    border-radius: 14px;
    max-width: 100%;
    overflow: hidden;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-header__title {
    font-size: 0.65rem;
    letter-spacing: 1.5px;
  }

  .section-body {
    padding: 14px;
    overflow: hidden;
    word-break: break-word;
  }

  .form-row {
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
  }

  .form-label {
    flex: none;
    width: 100%;
    font-size: 0.72rem;
    padding-top: 0;
    margin-bottom: 2px;
  }

  .form-field {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .form-field >>> .v-input {
    width: 100% !important;
  }

  .form-field >>> .v-input__control {
    width: 100% !important;
  }

  .form-field >>> .v-input__slot {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .file-card {
    flex-wrap: wrap;
    gap: 10px;
  }

  .file-card__info {
    flex-basis: calc(100% - 60px);
  }

  .file-card__actions {
    width: 100%;
    justify-content: flex-end;
  }

  .file-card__cn-no {
    width: 100%;
    flex-direction: row;
    gap: 8px;
  }

  .cn-status-banner {
    font-size: 0.78rem;
    padding: 12px 14px;
  }

  .claim-confirm-card {
    padding: 24px 20px 20px;
  }

  .claim-confirm-card__title {
    font-size: 1.05rem;
  }
}

/* Tablet breakpoint */
@media (min-width: 600px) and (max-width: 959px) {
  .claim-page {
    zoom: 1;
  }

  .claim-header__top {
    padding: 20px 20px 14px;
  }

  .claim-header__title {
    font-size: 1.15rem;
  }

  .claim-header__actions {
    flex-wrap: wrap;
    gap: 4px;
  }

  .section-body {
    padding: 18px;
  }

  .form-label {
    flex: 0 0 160px;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .date-card {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .date-card__label {
  color: var(--app-text-faint);
}

.dark-mode .date-card__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
  color: var(--app-text-faint);
}

.dark-mode .date-card__trigger:hover {
  border-color: var(--app-field-border-hover);
  background: var(--app-field-hover);
}

.dark-mode .date-card__value {
  color: var(--app-text);
}

.dark-mode .email-compose {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .email-compose__toolbar {
  background: linear-gradient(135deg, var(--app-page), var(--app-card));
}

.dark-mode .email-compose__fields {
  border-bottom-color: var(--app-border);
}

.dark-mode .email-field {
  border-bottom-color: var(--app-border);
}

.dark-mode .email-field__label {
  color: var(--app-text-faint);
}

.dark-mode .email-compose__body {
  border-top-color: var(--app-border);
}

.dark-mode .email-attachments {
  background: var(--app-form-tile);
  border-top-color: var(--app-border);
}

.dark-mode .email-attachments__header {
  color: var(--app-text-faint);
  border-bottom-color: var(--app-border);
}

.dark-mode .email-atch {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .email-atch:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .email-atch--empty {
  background: var(--app-form-tile);
}

.dark-mode .email-atch__icon--pdf {
  background: var(--app-danger-bg);
  color: var(--app-danger-fg);
}

.dark-mode .email-atch__icon--cn {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .email-atch__name {
  color: var(--app-text);
}

.dark-mode .email-atch__meta {
  color: var(--app-text-faint);
}

.dark-mode .email-atch__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .email-atch__btn:hover {
  background: var(--app-border);
  color: var(--app-neutral-fg);
}

.dark-mode .email-atch__lock-badge {
  background: var(--app-form-tile);
  color: var(--app-text-faint);
}

.dark-mode .cn-status-banner--success {
  background: var(--app-success-bg);
  border-color: var(--app-success-fg);
  color: var(--app-success-fg);
}

.dark-mode .cn-status-banner--error {
  background: var(--app-danger-bg);
  border-color: var(--app-danger-fg);
  color: var(--app-danger-fg);
}

.dark-mode .claim-header {
  background: var(--app-card);
}

.dark-mode .claim-header__title {
  color: var(--app-text);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-card);
}

.dark-mode .section-header {
  background: linear-gradient(135deg, var(--app-accent), var(--app-accent));
}

.dark-mode .section-header--teal {
  background: linear-gradient(135deg, var(--app-success), var(--app-success));
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .form-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot:hover {
  background: var(--app-field-hover) !important;
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--app-accent) !important;
  box-shadow: 0 0 0 3px var(--app-ring) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text);
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-field-placeholder);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot,
.dark-mode .form-field >>> .v-input--is-readonly .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection,
.dark-mode .form-field >>> .v-input--is-readonly input {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-chip {
  background: var(--app-accent-soft) !important;
  color: var(--app-accent-strong) !important;
  border-color: var(--app-accent) !important;
}

.dark-mode .form-field >>> .v-chip .v-icon {
  color: var(--app-accent) !important;
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-neutral-fg);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-success-bg);
  color: var(--app-success-fg);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-success);
  color: var(--app-success-fg);
}

.dark-mode .rv-datepicker__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .file-card {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .file-card--empty {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .file-card--has-file {
  background: var(--app-success-bg);
  border-color: var(--app-success-fg);
}

.dark-mode .file-card--disabled {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .file-card__icon {
  background: var(--app-form-tile);
}

.dark-mode .file-card--has-file .file-card__icon {
  background: var(--app-success);
}

.dark-mode .file-card__svg {
  color: var(--app-text-muted);
}

.dark-mode .file-card--has-file .file-card__svg {
  color: var(--app-success-fg);
}

.dark-mode .file-card__name {
  color: var(--app-text);
}

.dark-mode .file-card--empty .file-card__name,
.dark-mode .file-card--disabled .file-card__name {
  color: var(--app-text-faint);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  background: var(--app-form-tile);
  border-color: var(--app-border);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-accent-soft);
  border-color: var(--app-accent);
  color: var(--app-accent-strong);
}

.dark-mode .file-card__cn-no {
  background: var(--app-form-tile);
  border-color: var(--app-border);
}

.dark-mode .file-card__cn-label {
  color: var(--app-text-faint);
}

.dark-mode .file-card__cn-value {
  color: var(--app-text);
}

.dark-mode .tiptap-container {
  border-color: var(--app-border);
}

.dark-mode .tiptap-container:focus-within {
  border-color: var(--app-accent);
  box-shadow: 0 0 0 3px var(--app-ring);
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  color: var(--app-accent-strong);
  border-color: var(--app-form-tile-border);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent-strong);
}

.dark-mode .claim-confirm-card__btn--confirm {
  background: var(--app-accent);
}

.dark-mode .claim-confirm-card__btn--confirm:hover {
  background: var(--app-accent);
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection,
.dark-mode .form-field >>> .v-input--is-readonly input {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .email-field__input input {
  color: var(--app-text) !important;
}

.dark-mode .email-compose__body .tiptap-vuetify-editor .v-toolbar {
  border-bottom: 1px solid var(--app-border) !important;
  background: var(--app-surface) !important;
}

.dark-mode .email-compose__body .tiptap-vuetify-editor .ProseMirror {
  color: var(--app-text) !important;
}

.dark-mode .tiptap-container .tiptap-vuetify-editor .v-toolbar {
  border-bottom: 1px solid var(--app-border) !important;
}

.dark-mode .tiptap-container .ProseMirror {
  color: var(--app-text);
}

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top: 1px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* ============================================
   CONFIRM DIALOG BORDER RADIUS (unscoped)
   ============================================ */
.claim-confirm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

/* ============================================
   EMAIL COMPOSE INPUT OVERRIDES (unscoped)
   ============================================ */
.email-field__input.v-text-field.v-text-field--solo > .v-input__control > .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 32px !important;
}

.email-field__input.v-input--is-focused > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}

.email-field__input input {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  color: #1e293b !important;
}

.email-chip {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  height: 26px !important;
}

/* Tiptap inside email compose */
.email-compose__body .tiptap-vuetify-editor .v-card {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

.email-compose__body .tiptap-vuetify-editor .v-toolbar {
  box-shadow: none !important;
  border-bottom: 1px solid #f1f5f9 !important;
  background: #f8fafc !important;
}

.email-compose__body .tiptap-vuetify-editor .ProseMirror {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.88rem !important;
  color: #334155 !important;
  min-height: 200px !important;
  padding: 20px !important;
  line-height: 1.7 !important;
}

.email-compose__body .tiptap-vuetify-editor .ProseMirror:focus {
  outline: none;
}

/* Dark mode */
.dark-mode .email-field__input input {
  color: var(--app-text) !important;
}

.dark-mode .email-chip {
  background: var(--app-accent-soft) !important;
  color: var(--app-accent) !important;
}

.dark-mode .email-compose__body .tiptap-vuetify-editor .v-toolbar {
  background: var(--app-card) !important;
  border-bottom-color: var(--app-border) !important;
}

.dark-mode .email-compose__body .tiptap-vuetify-editor .ProseMirror {
  color: var(--app-text) !important;
  background: var(--app-form-tile) !important;
}

/* ============================================
   TIPTAP EDITOR OVERRIDES (unscoped — legacy)
   ============================================ */
.tiptap-container .tiptap-vuetify-editor .v-card {
  box-shadow: none !important;
  border: none !important;
}

.tiptap-container .tiptap-vuetify-editor .v-toolbar {
  box-shadow: none !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.tiptap-container .ProseMirror {
  min-height: 150px;
  padding: 14px 16px;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #334155;
  line-height: 1.6;
}

.tiptap-container .ProseMirror:focus {
  outline: none;
}

.dark-mode .tiptap-container .tiptap-vuetify-editor .v-card {
  background: var(--app-form-tile) !important;
}

.dark-mode .tiptap-container .tiptap-vuetify-editor .v-toolbar {
  background: var(--app-card) !important;
  border-bottom-color: var(--app-border) !important;
}

.dark-mode .tiptap-container .ProseMirror {
  color: var(--app-text);
}

/* ============================================
   VUETIFY DATE PICKER OVERRIDE (unscoped)
   ============================================ */
.v-picker {
  border-radius: 14px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  overflow: hidden;
  font-family: 'Lato', sans-serif !important;
}

.v-picker .v-picker__body {
  border: none !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.v-picker__body {
  background: #fff !important;
}

/* Month/year header */
.v-date-picker-header {
  padding: 12px 16px 8px !important;
  background: #fff !important;
}

.v-date-picker-header__value button {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  color: #1e293b !important;
}

.v-date-picker-header .v-btn {
  color: #64748b !important;
}

.v-date-picker-header .v-btn:hover {
  background: #f1f5f9 !important;
}

/* Weekday headers */
.v-date-picker-table thead th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  padding: 8px 0 !important;
}

/* Day buttons */
.v-date-picker-table .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.v-date-picker-table .v-btn:hover {
  background: #f0f9ff !important;
}

.v-date-picker-table .v-btn--active {
  background: #0ea5e9 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.v-date-picker-table .v-btn--active:hover {
  background: #0284c7 !important;
}

/* Today indicator */
.v-date-picker-table .v-btn--outlined {
  border-color: #0ea5e9 !important;
  color: #0ea5e9 !important;
}

/* Disabled days */
.v-date-picker-table .v-btn--disabled {
  color: #cbd5e1 !important;
}

/* Action buttons (Cancel/OK) */
.v-picker__actions {
  padding: 8px 16px 14px !important;
  background: #fff !important;
  border-top: 1px solid #f1f5f9 !important;
}

.v-picker__actions .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
}

/* Month picker */
.v-date-picker-years li,
.v-date-picker-months .v-btn {
  font-family: 'Lato', sans-serif !important;
}

/* Dark mode datepicker */
.dark-mode .v-picker {
  border-color: var(--app-border) !important;
  box-shadow: 0 8px 30px var(--app-shadow-mid) !important;
}

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-neutral-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table .v-btn--active {
  background: var(--app-accent) !important;
  color: var(--app-accent-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top-color: var(--app-border) !important;
}
</style>
